import { ViewModel,View } from "binder"
import { getAsBoolean, getAsNumber } from "src/uicomponents/components/utilities";
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { ServerSideDataLoaderView } from "./serverSideDataLoader-view"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IMemberContainer } from "../../../dataModelBuilder-viewModel";

export class ServerSideDataLoaderViewModel extends ViewModel  implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.disableAutoLoad = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new ServerSideDataLoaderView();
    }
    public getTypeId(): string {
        return "VM-81AF08DE-C5F9-40CC-A8D9-892B36AC0D39"
    }
    public set functionName(v: string) { this._functionName = v; } public get functionName(): string { return this._functionName;} private _functionName: string;
    public set pageSize(v: number) { this._pageSize = getAsNumber(v); } public get pageSize(): number { return this._pageSize;} private _pageSize: number;
    public set disableAutoLoad(v: boolean) { this._disableAutoLoad = getAsBoolean(v); } public get disableAutoLoad(): boolean { return this._disableAutoLoad;} private _disableAutoLoad: boolean;
    
    setDefaultValue(defaultValue: any): void {
        this.functionName = defaultValue?.FunctionName ?? "";
        this.pageSize = defaultValue?.PageSize ?? 15;
        this.disableAutoLoad = defaultValue?.DisableAutoLoad ?? false;
    }
    getDefaultValue() {
        return {
            FunctionName : this.functionName,
            PageSize : this.pageSize,
            DisableAutoLoad : this.disableAutoLoad
        }
    }
    verify(owningClass : IMemberContainer): string[] {
        let result = [];
        if(stringIsNullOrEmpty(this.functionName)){
            result.push('function name is not specified.')
        }
        if(this.pageSize<=0){
            result.push('page size shall be positive')
        }
        if(owningClass.hasMethod(this.functionName)==false){
            result.push(`function named "${this.functionName}" is not defined in ViewModel "${owningClass.getName()}"`)
        }
        return result;
    }

}
